import { render, staticRenderFns } from "./VCardTitleWithButton.vue?vue&type=template&id=8af35fbe&scoped=true"
import script from "./VCardTitleWithButton.vue?vue&type=script&lang=js"
export * from "./VCardTitleWithButton.vue?vue&type=script&lang=js"
import style0 from "./VCardTitleWithButton.vue?vue&type=style&index=0&id=8af35fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af35fbe",
  null
  
)

export default component.exports